import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "gfu-layout__main _my-6 js-main-content",
  "data-qa": "project-try-it"
}
const _hoisted_2 = { class: "gfu-content-head _flex _jc-sb _ai-c _gap-2" }
const _hoisted_3 = { class: "gfu-project-try-it__frame-container _mt-3" }
const _hoisted_4 = ["src", "title"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_project_navigation = _resolveComponent("project-navigation")
  const _component_base_title = _resolveComponent("base-title")
  const _component_icon_base_button = _resolveComponent("icon-base-button")
  const _component_progress_overlay = _resolveComponent("progress-overlay")

  return (_openBlock(), _createElementBlock("div", null, [
    _cache[1] || (_cache[1] = _createElementVNode("div", { id: "navigation" }, null, -1 /* CACHED */)),
    _createVNode(_component_project_navigation, {
      items: $props.navigation.items
    }, null, 8 /* PROPS */, ["items"]),
    _createElementVNode("main", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_base_title, {
          as: "h2",
          level: "h1",
          "data-qa": "page-title"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.Resources.ProjectHome.TryItNavbarLink), 1 /* TEXT */)
          ]),
          _: 1 /* STABLE */
        }),
        ($data.embedUrl && $data.isFullscreenSupported)
          ? (_openBlock(), _createBlock(_component_icon_base_button, {
              key: 0,
              icon: "expand",
              theme: "accent",
              size: "default",
              "text-transform": "none",
              onClick: $options.onFullscreenClick,
              "data-qa": "project-try-it:Fullscreen"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.Resources.ProjectHome.TryItFullscreenButton), 1 /* TEXT */)
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["onClick"]))
          : ($data.embedUrl)
            ? (_openBlock(), _createBlock(_component_icon_base_button, {
                key: 1,
                tag: "a",
                href: $data.embedUrl,
                target: "_blank",
                rel: "noopener noreferrer",
                icon: "external-link",
                theme: "accent",
                size: "default",
                "text-transform": "none",
                "data-qa": "project-try-it:OpenInNewWindow"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.Resources.ProjectHome.TryItOpenInNewWindowButton), 1 /* TEXT */)
                ]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["href"]))
            : _createCommentVNode("v-if", true)
      ]),
      _createElementVNode("div", _hoisted_3, [
        ($data.embedUrl)
          ? (_openBlock(), _createElementBlock("iframe", {
              key: 0,
              ref: "frame",
              src: $data.embedUrl,
              title: _ctx.Resources.ProjectHome.TryItSimulatorFrameTitle,
              class: "gfu-project-try-it__frame",
              loading: "lazy",
              allow: "fullscreen",
              sandbox: "allow-scripts allow-same-origin allow-popups",
              referrerpolicy: "strict-origin-when-cross-origin",
              onLoad: _cache[0] || (_cache[0] = (...args) => ($options.onFrameLoad && $options.onFrameLoad(...args))),
              "data-qa": "project-try-it:Frame"
            }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_4))
          : _createCommentVNode("v-if", true),
        _createVNode(_component_progress_overlay, { visible: $data.isLoading }, null, 8 /* PROPS */, ["visible"])
      ])
    ])
  ]))
}